import { memo } from 'react'

const ScheduleMeetingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="99"
      fill="none"
      viewBox="0 0 100 99"
    >
      <path
        fill="#8E33FF"
        d="M50 74c19.606 0 35.5-15.894 35.5-35.5S69.606 3 50 3 14.5 18.894 14.5 38.5 30.394 74 50 74"
        opacity="0.3"
      ></path>
      <g filter="url(#filter0_d_2269_17218)">
        <path
          fill="url(#paint0_linear_2269_17218)"
          d="M77.86 13.693V63.17a2.547 2.547 0 0 1-2.534 2.535H24.805a2.547 2.547 0 0 1-2.533-2.535V13.693a2.546 2.546 0 0 1 2.533-2.535h50.521a2.547 2.547 0 0 1 2.533 2.535"
        ></path>
      </g>
      <path
        fill="#212B36"
        d="M77.86 13.693v1.84H22.271v-1.84a2.546 2.546 0 0 1 2.533-2.535h50.521a2.547 2.547 0 0 1 2.533 2.535"
      ></path>
      <path
        fill="#FF5630"
        d="M24.928 14.142a.775.775 0 1 0 0-1.553.776.776 0 1 0 0 1.553"
      ></path>
      <path
        fill="#FFAB00"
        d="M27.337 14.142a.775.775 0 0 0 .297-1.494.775.775 0 0 0-1.073.718.777.777 0 0 0 .776.776"
      ></path>
      <path
        fill="#22C55E"
        d="M29.79 14.142a.775.775 0 0 0 .548-1.326.776.776 0 1 0-.549 1.326"
      ></path>
      <path
        fill="#C2C8D6"
        d="M50.496 30.675a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M57.76 30.675a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M65.02 30.675a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M72.283 30.675a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M28.71 37.938a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M35.973 37.938a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M43.235 37.938a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M50.496 37.938a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M57.76 37.938a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M65.02 37.938a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M72.283 37.938a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M28.71 45.2a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M35.973 45.2a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M43.235 45.2a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M50.496 45.2a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M57.76 45.2a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15"
      ></path>
      <path
        fill="#8E33FF"
        d="M65.02 45.2a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15"
      ></path>
      <path
        fill="#C2C8D6"
        d="M72.283 45.2a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M28.71 52.462a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M35.973 52.462a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M43.235 52.462a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M50.496 52.462a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M57.76 52.462a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M65.02 52.462a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M72.283 52.462a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M28.71 59.724a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M35.973 59.724a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M43.235 59.724a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15M50.496 59.724a2.075 2.075 0 1 0 0-4.15 2.075 2.075 0 0 0 0 4.15"
      ></path>
      <g fill="#C2C8D6" opacity="0.5">
        <path d="M30.007 20.495h-2.593a.778.778 0 0 0 0 1.556h2.593a.778.778 0 1 0 0-1.556M37.27 20.495h-2.594a.778.778 0 0 0 0 1.556h2.594a.778.778 0 0 0 0-1.556M44.532 20.495h-2.594a.778.778 0 0 0 0 1.556h2.594a.778.778 0 0 0 0-1.556M51.793 20.495h-2.594a.778.778 0 0 0 0 1.556h2.594a.778.778 0 1 0 0-1.556M59.056 20.495h-2.594a.778.778 0 0 0 0 1.556h2.594a.778.778 0 0 0 0-1.556M66.318 20.495h-2.594a.778.778 0 0 0 0 1.556h2.594a.778.778 0 1 0 0-1.556M73.58 20.495h-2.594a.778.778 0 0 0 0 1.556h2.594a.778.778 0 0 0 0-1.556"></path>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2269_17218"
          x1="50.047"
          x2="50.047"
          y1="9.896"
          y2="66.294"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFEFF"></stop>
          <stop offset="0.996" stopColor="#ECF0F5"></stop>
        </linearGradient>
        <filter
          id="filter0_d_2269_17218"
          width="99.587"
          height="98.548"
          x="0.272"
          y="0.158"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="11"></feOffset>
          <feGaussianBlur stdDeviation="11"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2269_17218"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_2269_17218"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  )
}

export default memo(ScheduleMeetingIcon);
